export default "cornerstone3DTools@^0.1.0";
